<template>
  <div
    class="tw-flex tw-items-center tw-justify-center tw-space-x-4 tw-bg-neutral-600 tw-py-3 tw-text-xs tw-font-medium tw-text-white"
  >
    <div>Your account is not active yet.</div>
    <InertiaLink
      :href="firstItemToComplete.href"
      class="tw-inline-flex tw-items-center"
      test_id="profile-incomplete-status-bar"
    >
      ({{ progressInPercent }}%) {{ firstItemToComplete.description }}
      <BaseIcon name="arrow-sm-right" class="tw-ml-1 tw-h-4 tw-w-4" />
    </InertiaLink>
  </div>
</template>

<script setup>
import BaseIcon from '@/shared/components/BaseIcon.vue'
import { useUserProfileCompletion } from '@/shared/composables/useUserProfileCompletion.js'

const { progressInPercent, firstItemToComplete } = useUserProfileCompletion()
</script>
